import { Component, OnInit, Input } from '@angular/core';
import { Patient } from '../../../models/patient.model';

@Component({
  selector: 'app-patient-short-detail',
  templateUrl: './patient-short-detail.component.html'
})
export class PatientShortDetailComponent {

  @Input() patient: Patient;

}
